export default __webpack_public_path__ + "static/media/files-glery5.b29ae4f1.jpg";